import { Geolocation } from '@capacitor/geolocation';
import { LocationFetchError, LocationOOBException } from '../../shared/exceptions';
import { isInBoundingBox } from '../../shared/location-utils';
import { Point } from '../../types';

export const fetchCurrentLocation = async (bounds?: number[][]): Promise<Point> => {
  let coordinates: [number, number];
  try {
    const {
      coords: { longitude, latitude },
    } = await Geolocation.getCurrentPosition();
    coordinates = [longitude, latitude];
  } catch {
    throw new LocationFetchError();
  }
  if (bounds) {
    if (!isInBoundingBox(bounds, coordinates)) {
      throw new LocationOOBException();
    }
  }
  return { type: 'Point', coordinates };
};
